import Alert from 'antd/es/alert';
import { withConfigProvider } from '../config-provider';
export default withConfigProvider(Alert);
